import { PrimeNGConfig } from 'primeng/api';
import { MenuItem } from 'primeng/api/menuitem';

import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from 'src/app/services/settings.service';
import { CommonService } from 'src/app/services/common.service';
import { User } from 'src/app/models/user';
import { RaceService } from 'src/app/services/race.service';
import { AuthService } from 'src/app/services/auth.service';

export interface EventData {
  action: 'show_auth' | 'check_auth';
}

export interface EventMessage {
  data: EventData;
  origin: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: []
})
export class HeaderComponent implements OnInit {
  public visibleTopBar = false;

  items: MenuItem[] = [];

  constructor(
    public appSettings: SettingsService,
    public raceService: RaceService,
    public authService: AuthService,
    private cdr: ChangeDetectorRef,
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private _location: Location,
    private commonService: CommonService
  ) {
    this.raceService.showAuthModel.subscribe(() => {
      this.setStatusVisibleTopBar();
    });
  }

  showHideTopBar(e: any) {
    e?.stopPropagation();
    this.setStatusVisibleTopBar();
    return false;
  }

  setStatusVisibleTopBar() {
    this.visibleTopBar = !this.visibleTopBar;
  }

  ngOnInit() {
    window.addEventListener('message', (message: EventMessage) => {
      if (message.data.action === 'show_auth') {
        if (this.authService.user && !this.authService.user?.setData) {
          this.showHideTopBar(null);
          this.cdr.detectChanges();
        } else {
          this.authService.refresh.emit();
        }
      }
    });

    this.primengConfig.ripple = true;
    this.items = [
      {
        label: this.appSettings.translate[this.appSettings.selectedLang]['profile'],
        icon: 'pi pi-user',
        command: () => {
          this.router.navigate(['profile'], { relativeTo: this.activateRoute });
        },
      },
      {
        label: this.appSettings.translate[this.appSettings.selectedLang]['exit'],
        icon: 'pi pi-reply',
        command: (event: any) => {
          if (!event.originalEvent.target) {
            return;
          }
          this.commonService.confirm({
            header: this.appSettings.translate[this.appSettings.selectedLang]['exit'],
            message: this.appSettings.translate[this.appSettings.selectedLang]['exitConfirm'],
            acceptLabel: this.appSettings.translate[this.appSettings.selectedLang]['yes'],
            rejectLabel: this.appSettings.translate[this.appSettings.selectedLang]['no'],
            accept: () => {
              const subscribe = this.authService.exitNow().subscribe(() => {
                subscribe.unsubscribe();
              });
            }
          });
        },
      },
    ];
  }

  backClicked() {
    this._location.back();
  }

  detectChange(e: any) {
    this.cdr.detectChanges();
  }

  loginNow(user: User | null) {
    this.authService.setUser(user);
    this.visibleTopBar = false;

    if (this.authService.user && !this.authService.user?.setData) {
      this.router.navigate(['profile'], { relativeTo: this.activateRoute });
    } else {
      this.authService.refresh.emit();
    }
  }
}
